export default class ContractInfo {
  id = null;
  facility = null;
  contractStart = null;
  contractEnd = null;

  monthlyCost = null;
  yearlyCost = null;

  company = null
  companyName = null;
  unknownCompany = null;

  parameters = [];

  contractValid = null;

  noticePeriodQuarterly = null;
  term = null;
  documentation = null;
  note = null;
  costsInNet = false;
  types = [];
  name = "";

  hourlyRates = [];
  automaticRenewal = false;
  renewalYears = 1;  // default 1 year - must not be 0 or null
  proTypeCosts = [];
  costYearly = true;
  costProType = false;

  constructor() {
  }
}
